module.exports = __webpack_public_path__ + "13c3a8a725d5d8ea051936d089a1eb3d.svg";